import { useEffect, useState } from "react"

/**
 * Хук для отслеживания ширины и детектирования перехода
 * @param {number} smallBreakpoint - брейкпоинт смены экрана с маленького на большой
 * @returns { width: number; isSmallToLarge: boolean } - новая ширина и было ли изменения с мелкого экрана на большой
 */
const useScreenSizeTransition = (smallBreakpoint = 1200) => {
  const [width, setWidth] = useState(window?.innerWidth)
  const [isSmallToLarge, setIsSmallToLarge] = useState<boolean>(false)

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth

      // Если раньше был маленький экран, а теперь стал больше порога
      if (width < smallBreakpoint && newWidth >= smallBreakpoint) {
        setIsSmallToLarge(true)
      }
      // Если был большой, а стал маленьким — сбрасываем флаг
      else if (width >= smallBreakpoint && newWidth < smallBreakpoint) {
        setIsSmallToLarge(false)
      }

      setWidth(newWidth)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [width, smallBreakpoint])

  return { width, isSmallToLarge }
}

export default useScreenSizeTransition
